import './gridplusoverlay.scss';
import $ from 'jquery';
import 'brandhub-embxp-frontend/src/common/js/lazyload/lazyload';

$(document).ready(function () {
  var isLoading = false;
  var currentlyShownHref = null;
  var cachedContentByHref = {};

  $('.variant-thumbs-with-plus-icon .brandhub-thumb-item').each(function () {
    var itemElem = $(this);
    var containerElem = itemElem.closest('.container-outer');
    var linkElem = itemElem.find('a');
    var href = linkElem.attr('href');
    if (href && href.indexOf('#') !== 0) {
      if (location.pathname.indexOf('/app_dev.php') === 0) {
        href = '/app_dev.php' + href;
      }

      linkElem.on('click', function (evt) {
        evt.preventDefault();

        // hide already visible item...
        if (currentlyShownHref === href) {
          var oldOverlays = $('.grid-plus-overlay');
          oldOverlays.slideUp(500, function () {
            oldOverlays.remove();
            currentlyShownHref = null;
          });

          return;
        }

        // show new item...
        if (isLoading) {
          return;
        }
        isLoading = true;

        if (cachedContentByHref[href]) {
          showContent(cachedContentByHref[href]);
        } else {
          $.ajax({
            url: href,
            success: function (data) {
              var parsedData = $(data);
              var content = parsedData.find('.container-paragraph');
              if (!content) {
                content = parsedData.find('body');
              }
              if (!content) {
                content = parsedData;
              }
              content.addClass('grid-plus-overlay');
              content.prepend('<a href="#" class="grid-plus-overlay-close-btn"><i class="brandhub-icon brandhub-icon-close"></i></a>');

              cachedContentByHref[href] = content;
              showContent(cachedContentByHref[href]);
            },
            error: function () {
              alert('Error loading detail data');
              isLoading = false;
            }
          });
        }

        function showContent (content) {
          var oldOverlays = $('.grid-plus-overlay');
          if (oldOverlays.length) {
            oldOverlays.remove(); // remove old overlays
          }
          if (currentlyShownHref) {
            content.fadeOut(0);
            content.insertBefore(containerElem);
            content.fadeIn(500);
          } else {
            content.hide();
            content.insertBefore(containerElem);
            content.slideDown(1000);
          }
          setTimeout(function () {
            $('html, body').animate({
              'scrollTop': content.offset().top - $('header').height()
            }, 1000);
            content.find('img').lazyLoadXT();
          }, 0);
          content.find('.grid-plus-overlay-close-btn').on('click', function (closeClickEvt) {
            closeClickEvt.preventDefault();
            var oldOverlays = $('.grid-plus-overlay');
            oldOverlays.slideUp(500, function () {
              oldOverlays.remove();
              currentlyShownHref = null;
            });
          });

          currentlyShownHref = href;
          isLoading = false;
        }
      });
    }
  });
});



// WEBPACK FOOTER //
// ./src/components/gridplusoverlay/gridplusoverlay.js